import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  OneBureauSliceState,
  OneBureauCreditReportResponse,
  OneBureauSummary,
  OneBureauBureau,
} from './types';

const initialState: OneBureauSliceState = {
  report: null,
  summary: null,
  pollingStartedAt: null,
  bureau: null,
  needsVerification: false,
  canReRequest: false,
};

const creditReportOneBureauSlice = createAppSlice({
  name: 'creditReportOneBureau',
  initialState,
  reducers: {
    setOneBureauReport(
      state,
      action: PayloadAction<OneBureauCreditReportResponse>,
    ) {
      state.report = action.payload;
    },
    clearOneBureauReport(state) {
      state.report = null;
      state.pollingStartedAt = null;
      state.needsVerification = false;
      state.canReRequest = false;
    },
    // BRD Q6: summary shape pending confirmation; typed as unknown.
    setOneBureauSummary(state, action: PayloadAction<OneBureauSummary>) {
      state.summary = action.payload;
    },
    clearOneBureauSummary(state) {
      state.summary = null;
    },
    setOneBureauPollingStartedAt(state, action: PayloadAction<number>) {
      state.pollingStartedAt = action.payload;
    },
    setOneBureauBureau(state, action: PayloadAction<OneBureauBureau>) {
      state.bureau = action.payload;
    },
    setOneBureauNeedsVerification(state, action: PayloadAction<boolean>) {
      state.needsVerification = action.payload;
    },
    setOneBureauCanReRequest(state, action: PayloadAction<boolean>) {
      state.canReRequest = action.payload;
    },
  },
});

export const {
  setOneBureauReport,
  clearOneBureauReport,
  setOneBureauSummary,
  clearOneBureauSummary,
  setOneBureauPollingStartedAt,
  setOneBureauBureau,
  setOneBureauNeedsVerification,
  setOneBureauCanReRequest,
} = creditReportOneBureauSlice.actions;

export default creditReportOneBureauSlice.reducer;
